import { useAuth } from "@hooks";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

/**
 * For pre-authentication pages that you should not be able to go to after authentication.
 * Redirects to the `next` query param if present, otherwise to the given defaultPath.
 *
 * @param {string} defaultPath - Where to send the user when no `?next` param is present.
 *   Login uses the default ("/dashboard"); Register passes "/welcome" so new users
 *   land on the welcome/activation page exactly once.
 */
export function useRedirectAuthenticatedUsers(
  defaultPath = "/dashboard",
) {
  const navigate = useNavigate();
  const { isUserAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next");

  useEffect(() => {
    if (!isUserAuthenticated) {
      return;
    }

    if (next) {
      navigate(next);
      return;
    }

    navigate(defaultPath);
  }, [isUserAuthenticated, navigate, next, defaultPath]);

  return null;
}
